import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useField, type RuleExpression } from 'vee-validate';
import { toRef } from 'vue';

type Props = {
    rules: RuleExpression<unknown>;
    required?: boolean;
    name: string;
    modelValue: string;
    validateOnValueUpdate?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    rules: {},
    required: { type: Boolean },
    name: {},
    modelValue: {},
    validateOnValueUpdate: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const rulesRef = toRef(props, 'rules');

const { value, errorMessage, handleChange } = useField(() => props.name, rulesRef, {
    syncVModel: true,
    validateOnValueUpdate: props.validateOnValueUpdate
});


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps(_ctx.$attrs, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    "error-messages": _unref(errorMessage),
    masked: "false",
    variant: "outlined",
    class: "custom-text-field",
    onBlur: _unref(handleChange)
  }), _createSlots({ _: 2 }, [
    (_ctx.required)
      ? {
          name: "prepend-inner",
          fn: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sz-red--text" }, "*", -1))
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "error-messages", "onBlur"]))
}
}

})